import { Col, Row } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const LeftSection = styled(Flex)`
  gap: 20px;
  flex-wrap: wrap;
`

export const StyledButton1 = styled.button`
  width: 159px;
  height: 38px;
  top: 308px;
  left: 250px;
  gap: 0px;
  border-radius: 22px 22px;
  border: none;
  cursor: pointer;

  background-color: ${props => (props.isSelected ? ' #3249D7' : '#f0f0f0')};
  color: ${props => (props.isSelected ? 'white' : 'black')};
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-weight: ${props => (props.isSelected ? ' 800' : '400')};
  line-height: 18px;
  text-align: center;
`
export const SectionWrapper = styled(Flex)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
`
export const RightSection = styled(Flex)`
  display: flex;

  justify-content: flex-end;
`
export const date = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
`

export const SpinWrapper = styled(Flex)`
  padding-top: 25%;
`
export const EventExpiry = styled.div`
  color: rgba(62, 62, 62, 1);
  font-size: 12px;
  font-weight: 700;
  margin-left: auto;
`

export const EmptyStateContainer = styled.div`
  height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: gray;
  flex-direction: column;
`

export const HorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid #ccc; // Customize the border color
  margin: 20px 0; // Customize the margin
  width: 100%; // Customize the width
  margin-bottom: 0;
`
export const DateDisplay = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: left;
  padding: 10px;
`
export const Container = styled.div`
  gap: 10px
  // margin-top:-20px;
  width: 100%;
`

export const CompletedText = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 12px;
  font-weight: 400;
  color: rgba(113, 113, 113, 1);
`
export const VerticalLine = styled.div`
  height: 40px;
  border-left: 1.3px solid ${props => props.styleBasedObj?.borderColor};
  position: absolute;
  right: 0;
  display: ${props => (props.show ? 'block' : 'none')};
`

export const EventTitleSection = styled.div`
  width: ${props => (props.customWidth ? props?.customWidth : '320px')};
  padding-left: 30px;
  position: relative;
  display: flex;
  align-items: center;
`

export const EventTitle = styled.div`
  color: #000000;
  font-size: 20px;
  font-weight: 700;
  width: ${props =>
    props?.isWidth ? '250px' : props.ellipse ? '150px' : 'unset'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ${props => (props.ellipse ? 'ellipsis' : 'unset')};
  text-transform: capitalize;
`

export const EventCategory = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #000000;
`

export const EventHeading = styled.div`
  color: #717171;
  font-size: 12px;
  font-weight: 400;
`
export const EventAnswer = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;

`
export const EventAnswer1 = styled.div`
    width: 220px;
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-weight: 400;
    text-transform: capitalize;
    overflow: hidden;
    white-space: normal;
    word-wrap: normal;
    text-overflow: ellipsis; 

`
export const DynamicText = styled.div`
  color: #000000;
  font-size: ${props => (props?.size ? props?.size : '14px')};
  font-weight: ${props => (props?.fontWeight ? props?.fontWeight : 400)};
`

export const EventStatusCard = styled(Flex)`
  align-items: center;
  width: ${props => (props.width ? props.width : '100%')};
  padding: ${props => (props.padding ? props.padding : '10px 30px')};
  background: ${props => props.styleBasedObj?.bgColor};
  border: 1px solid ${props => props.styleBasedObj?.borderColor};
  border-radius: 10px;
  // opacity: 0.7;
  margin: auto;
  margin-top: ${props => props?.mTop};
  margin-bottom: ${props => props?.mBottom};
`

export const EventText = styled(Flex)`
  color: #717171;
  font-size: 12px;
  font-weight: 400;
  width: 100px;
  position: relative;
  display: flex;
  align-items: center;
`
export const EventDay = styled(Flex)`
  color: ${props => (props.allDayEvent ? '#717171' : '#000000')};
  font-size: ${props => (props.allDayEvent ? '12px' : '18px')};
  font-weight: ${props => (props.allDayEvent ? '400' : '700')};
  margin: ${props => (props.allDayEvent ? '' : '10px')}
`
export const EventDay1 = styled(Flex)`

font-size: 18px;
font-weight: 700;
line-height: 25px;
color: #000000;

`
export const StatusButton = styled(Button.Primary)`
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  padding: 6px 5px 6px 5px;
  border-radius: 10px;
  font-weight: 600;
  margin-left: ${props => (props?.mLeft ? props?.mLeft : 'auto')};
  // width: 106px;
  height: 35px;
  text-align: center;
  width: 110px;

  ${({ status }) => {
    switch (status) {
      case 'viewDetails':
        return `
          background-color: #FBFAFF;
          color: ${COLORS.PRIMARY};
           :hover {
            background: #FBFAFF;
            color: ${COLORS.PRIMARY};
          }
            :focus{
            background: #FBFAFF;
            color: ${COLORS.PRIMARY};
            }
        `
      case 'error':
        return `
          background-color: red;
          color: white;
        `
      case 'register':
        return `
          background-color: rgba(50, 73, 215, 1);
          color: #fff;
           :hover {
            background: rgba(50, 73, 215, 1);
            color: #fff;
          }
             :focus{
            background: rgba(50, 73, 215, 1);
            color: #fff;
            }
        `
      case 'cancel':
        return `
            background-color: #FBFAFF;
            color: ${COLORS.PRIMARY};
             :hover {
              background: #FBFAFF;
              color: ${COLORS.PRIMARY};
            }
              :focus{
              background: #FBFAFF;
              color: ${COLORS.PRIMARY};
              }
          `
      default:
        return `
            background-color: rgba(50, 73, 215, 1);
          color: #fff;
           :hover {
            background: rgba(50, 73, 215, 1);
            color: #fff;
          }
             :focus{
            background: rgba(50, 73, 215, 1);
            color: #fff;
            }
        `
    }
  }}
`

export const buttonStyle = {
  position: 'absolute',
  bottom: '10px',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '10px 20px',
  fontSize: '16px',
  backgroundColor: '#FFFFFFE5',
  color: 'black',
  border: 'none',
  cursor: 'pointer',
  borderRadius: ' 22.5px',
  width: '86px',
  height: '31px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
export const containerStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '1544px',
}

export const CloseBannerContainer = styled('div')(() => ({
  background: 'rgb(255, 255, 255)',
  position: 'absolute',
  width: '20px',
  borderRadius: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '20px',
  cursor: 'pointer',
  right: 10,
  top: 10,
}))
export const Category = styled.div`
  font-size: 24px;
  font-weight: 400;
`

export const FileName = styled('div')(() => ({
  color: 'rgba(50, 53, 56, 1)',
  fontSize: 14,
  fontWeight: 500,
}))

export const FileSize = styled('div')(() => ({
  color: 'rgba(50, 53, 56, 1)',
  fontSize: 10,
  fontWeight: 500,
}))

export const DownloadIconSec = styled('div')(() => ({
  marginLeft: 'auto',
  cursor: 'pointer',
}))

export const RegistrationText = styled('div')(() => ({
  fontSize: '12px',
  fontWeight: 700,
}))

export const StyledDivision = styled.div`
  //   text-align: center;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const EventName = styled.div`
  font-size: 24px;
  font-weight: 700;
`

export const EventSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`

export const EventRegistration = styled.div`
  border: 1px solid ${props => props.styleBasedObj?.borderColor};
  background: ${props =>
    props.darkBG ? props.styleBasedObj?.borderColor : '#fff'};
  border-radius: 47px;
  padding: 10px 15px;
  color: ${props => (props.darkBG ? props.styleBasedObj?.color : '#000')};
`

export const EventActionButton = styled.button`
  border: 1px solid ${props => props.styleBasedObj?.borderColor};
  background: ${props =>
    props?.type == 'filled' ? props.styleBasedObj?.borderColor : '#fff'};
  border-radius: 47px;
  padding: 10px 15px;
  color: ${props =>
    props?.type == 'filled'
      ? '#fff'
      : props.darkBG
      ? props.styleBasedObj?.color
      : '#000'};
  width: 86px;
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
`

export const EventRegistrationText = styled.div`
  font-size: 14px;
  font-weight: ${props => props?.weight ?? 700};
  text-align: left;
`

export const StyledCol = styled(Col)(({ justify }) => ({
  display: 'flex',
  justifyContent: justify || 'start',
}))

export const StyledRow = styled(Row)(() => ({
  gap: '2rem',
}))

export const StyledFileCol = styled(Col)(() => ({
  display: 'flex',
  alignItems: 'end',
  gap: 10,
  border: '1px solid rgba(50, 73, 215, 1)',
  background: 'rgba(250, 250, 251, 1)',
  padding: 10,
  borderRadius: 8,
  marginTop: 20,
}))

export const PreviewTitle = styled('div')(() => ({
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '20px',
  marginBottom: '4px',
}))

export const PreviewAnswer = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
}))

export const LinkedInLink = styled('a')(() => ({
  color: 'rgba(50, 73, 215, 1)',
  fontSize: ' 14px',
  fontWeight: 700,
  lineHeight: '30px',
}))

export const DetailsSection = styled(Col)(() => ({
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20px',
}))

export const FileIconSec = styled('div')(() => ({
  //   display: 'flex',
  //   alignItems: 'center',
  //   gap: 10,
}))
